import React from 'react'

const Icon = ({ iconClass }) => (
    // Styling is global css in index.html
    <i class={`icofont ${iconClass}`} style={{color: '#4c86fa', fontSize: '9em'}}></i>
)

export default Icon


// WEBPACK FOOTER //
// ./src/scenes/LandingPage/Icon/index.js